import { Injectable } from '@angular/core';
import { FinancialCompaniesState, FinancialCompaniesStore } from './financial-companies.store';
import { JsonApiEntityService } from '../jsonentity/json-api-entity.service';
import { ApiService } from '../../services/api/api.service';
import { tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FinancialCompany } from './financial-company.model';

@Injectable({ providedIn: 'root' })
export class FinancialCompaniesService extends JsonApiEntityService<FinancialCompaniesState> {

  constructor(private financialCompaniesStore: FinancialCompaniesStore,
              private apiService: ApiService
  ) {
    super(financialCompaniesStore);
  }

  get<T>(idOrConfig?, config?): Observable<T> {
    if (idOrConfig) {
      return super.get(idOrConfig, config);
    } else {
      return this.apiService.get('financial-companies?limit=100')
        .pipe(
          tap(entities => {
            this.financialCompaniesStore.set(entities.data);
          }),
          map(data => data.data),
        );
    }
  }
}
